import { CompactUserResponse } from '../account';
import { BaseResponse } from '../common';
import { FCFormDataType } from '@modules/ManagementForms/Form/FormFields/types';
import { FolderId } from '../library';
import { CompactFormResponse } from '../managementFormTemplate';

export type ManagementFormID = string;
export type CommentId = string;

export interface ManagementFormResponse extends BaseResponse {
  id: ManagementFormID;
  folderId: FolderId;
  name: string;
  fields: FCFormDataType[];
  values: string;
  user: CompactUserResponse;
  canEdit: boolean;
  canForward: boolean;
  canAction: boolean;
  isClosed: boolean;
  canApprove: boolean;
  status: FormForwardUserStatus;
  forwards: FormForwardUserResponse[];
  logs: ManagementFormLogResponse[];
  isForwarded: boolean;
  comments: ManagementFormCommentResponse[];
  chainUsers: CompactUserResponse[];
  parent?: CompactFormResponse;
  hasTakenAction: boolean;
  canSeeComments: boolean;
}

export interface CompactManagementFormResponse extends BaseResponse {
  id: ManagementFormID;
  name: string;
  user: CompactUserResponse;
  canEdit: boolean;
}

export interface FormForwardUserResponse {
  id: string;
  from: CompactUserResponse;
  to: CompactUserResponse;
  formId: ManagementFormID;
  comments: string;
  status: FormForwardUserStatus;
}

export enum FormForwardUserStatus {
  draft = 'draft',
  pending = 'pending',
  approved = 'approved',
  rejected = 'rejected',
}

export interface ManagementFormLogResponse extends BaseResponse {
  id: string;
  description: string;
  type: ManagementFormLogType;
}

export enum ManagementFormLogType {
  created = 'created',
  updated = 'updated',
  forwarded = 'forwarded',
  approved = 'approved',
  rejected = 'rejected',
}

export interface ManagementFormCommentResponse extends BaseResponse {
  id: CommentId;
  formId: ManagementFormID;
  comment: string;
  createdAt: number;
  userId: string;
  user: CompactUserResponse;
  isOwner: boolean;
}

export enum FormForwardType {
  send = 'send',
  approval = 'approval',
}
